export default __webpack_public_path__ + "static/oven-a11915e74c433ff0167f4d61812c4d23.png";